<template>
  <div class="page">
    <HeaderTitle />
    <div class="row">
      <div class="col-12">
        <label>Регистрационный номер машины</label>
        <VSelect
          v-model="fueling.car_id"
          style="width: 100%"
          :options="cars"
          :reduce="option => option.id"
          label="registration_plate"
        >
          <template v-slot:option="option">
            {{ option.brand }} {{ option.model }}
            <sub>рег. номер: {{ option.registration_plate }}</sub>
          </template>
        </VSelect>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label>Тип топлива</label>
        <VSelect
          v-model="fueling.fuel_type_id"
          style="width: 100%"
          :options="fuels"
          :reduce="option => option.id"
          label="name"
        >
          <template v-slot:option="option">{{ option.name }}</template>
        </VSelect>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label>Отстаток, л</label>
        <input
          v-model="fueling.remaining"
          type="number"
          class="form-control"
          placeholder
          required
        >
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label>Заполнено, л</label>
        <input
          v-model="fueling.fueled"
          type="number"
          class="form-control"
          placeholder
          required
        >
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label>Расчет</label>
        <VSelect
          v-model="fueling.cash"
          class="w-100"
          :options="payments"
          :reduce="payment => payment.value"
          label="name"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label>Дата заправки</label>
        <input
          v-model="date"
          type="datetime-local"
          class="form-control"
          placeholder
          required
        >
      </div>
    </div>
    <hr class="mb-4">
    <button class="btn btn-primary mr-2" @click="createFueling()">Добавить</button>
    <router-link to="/fueling" class="btn btn-secondary">Отменить</router-link>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import Swal from 'sweetalert2'
import { mapActions, mapState } from 'vuex'
import userApi from '@/api/user'
import CarFuelingApi from '../../api/carFueling'

export default {
  name: 'CreateFueling',
  data () {
    return {
      isCreating: false,
      payments: [
        {
          name: 'Наличный расчет',
          value: true
        }, {
          name: 'Безналичный расчет',
          value: false
        }
      ],
      fueling: {
        car_id: 0,
        fuel_type_id: 0,
        author_id: 0,
        remaining: null,
        fueled: null,
        date: null,
        cash: false,
        create_at: 0
      }
    }
  },
  computed: {
    ...mapState('taxi/cars', {
      cars: state => state.items
    }),
    ...mapState('fuel/fuelType', {
      fuelTypes: state => state.items.filter(e => !e.archived_at)
    }),
    date: {
      get () {
        return dayjs(this.fueling.date).format('YYYY-MM-DDTHH:mm')
      },
      set (dateTime) {
        this.fueling.date = dayjs(dateTime, 'YYYY-MM-DDTHH:mm').format('YYYY-MM-DDTHH:mm:ssZZ')
      }
    },
    fuels: {
      get () {
        if (!this.fuelsCopy) {
          return JSON.parse(JSON.stringify(this.fuelTypes))
        }

        return this.fuelsCopy
      },
      set (value) {
        // eslint-disable-next-line no-unused-vars
        value.forEach((v, i) => {
          this.updateItem({ ...v })
        })
        this.fuelsCopy = value
      }
    }
  },
  beforeMount () {
    this.loadCars()
    this.loadFuels()
  },
  mounted () {
    this.setTitle([
      {
        title: 'Заправки',
        url: '/fueling'
      }, {
        title: 'Добавить'
      }
    ])
  },
  methods: {
    createFueling () {
      if (this.isCreating) {
        return
      }
      userApi
        .getCurrentUser()
        .then(user => {
          this.isCreating = true
          this.fueling.author_id = user.id
          CarFuelingApi.createItem(this.fueling)
            .then(() => {
              this.isCreating = false
              this.$router.push('/fueling')
            })
            .catch(err => {
              console.error(err)
              this.isCreating = false
              Swal.fire({
                icon: 'error',
                title: 'Ошибка',
                html: err.message
              })
            })
        })
        .catch(err => {
          console.error(err)
          this.isCreating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: err.message
          })
        })
    },
    ...mapActions('taxi', [
      'setTitle'
    ]),
    ...mapActions('taxi/cars', {
      loadCars: 'loadItems'
    }),
    ...mapActions('fuel/fuelType', {
      loadFuels: 'loadItems'
    })
  }
}
</script>
